import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function CalendarIcon({ color = "purple" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 11V13H7V11H9ZM13 11V13H11V11H13ZM17 11V13H15V11H17ZM19 4C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H6V2H8V4H16V2H18V4H19ZM19 20V9H5V20H19ZM9 15V17H7V15H9ZM13 15V17H11V15H13ZM17 15V17H15V15H17Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
